/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateVariableValueCommand,
  ErrorResponse,
  FunnelVariableDto,
  TestExpressionCommand,
  TestExpressionResponse,
  UpdateVariableValueCommand,
  VariableDto,
} from '../models/index';
import {
    CreateVariableValueCommandFromJSON,
    CreateVariableValueCommandToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FunnelVariableDtoFromJSON,
    FunnelVariableDtoToJSON,
    TestExpressionCommandFromJSON,
    TestExpressionCommandToJSON,
    TestExpressionResponseFromJSON,
    TestExpressionResponseToJSON,
    UpdateVariableValueCommandFromJSON,
    UpdateVariableValueCommandToJSON,
    VariableDtoFromJSON,
    VariableDtoToJSON,
} from '../models/index';

export interface CreateVariableValueRequest {
    createVariableValueCommand: CreateVariableValueCommand;
}

export interface DeleteVariableValueRequest {
    variableValueId: string;
}

export interface GetVariablesByContextRequest {
    contextObjectId: string;
}

export interface TestExpressionRequest {
    testExpressionCommand: TestExpressionCommand;
}

export interface UpdateVariableValueRequest {
    updateVariableValueCommand: UpdateVariableValueCommand;
}

/**
 * 
 */
export class ExpressionsApi extends runtime.BaseAPI {

    /**
     * Crée la valeur d\'une variable dans le contexte d\'un tunnel (typeContextVariable = Tunnel). Le back refuse une variable déjà redéfinie sur cet objet : « Cette variable est déjà redéfinie pour cet objet. » 
     * Rattacher une variable au tunnel
     */
    async createVariableValueRaw(requestParameters: CreateVariableValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunnelVariableDto>> {
        if (requestParameters['createVariableValueCommand'] == null) {
            throw new runtime.RequiredError(
                'createVariableValueCommand',
                'Required parameter "createVariableValueCommand" was null or undefined when calling createVariableValue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/expressions/variableValue`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateVariableValueCommandToJSON(requestParameters['createVariableValueCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunnelVariableDtoFromJSON(jsonValue));
    }

    /**
     * Crée la valeur d\'une variable dans le contexte d\'un tunnel (typeContextVariable = Tunnel). Le back refuse une variable déjà redéfinie sur cet objet : « Cette variable est déjà redéfinie pour cet objet. » 
     * Rattacher une variable au tunnel
     */
    async createVariableValue(requestParameters: CreateVariableValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunnelVariableDto> {
        const response = await this.createVariableValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supprimer la valeur d\'une variable
     */
    async deleteVariableValueRaw(requestParameters: DeleteVariableValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['variableValueId'] == null) {
            throw new runtime.RequiredError(
                'variableValueId',
                'Required parameter "variableValueId" was null or undefined when calling deleteVariableValue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/expressions/variableValue/delete/{VariableValueId}`.replace(`{${"VariableValueId"}}`, encodeURIComponent(String(requestParameters['variableValueId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Supprimer la valeur d\'une variable
     */
    async deleteVariableValue(requestParameters: DeleteVariableValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteVariableValueRaw(requestParameters, initOverrides);
    }

    /**
     * Définitions de variables sélectionnables lors du rattachement à un tunnel. Ce sont les variables elles-mêmes, pas leurs valeurs : celles-ci se lisent par contexte via /expressions/variablesValuesByContextNoPagedResult. 
     * Variables du référentiel (non paginé)
     */
    async getVariablesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VariableDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/expressions/variablesNoPagedResult`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VariableDtoFromJSON));
    }

    /**
     * Définitions de variables sélectionnables lors du rattachement à un tunnel. Ce sont les variables elles-mêmes, pas leurs valeurs : celles-ci se lisent par contexte via /expressions/variablesValuesByContextNoPagedResult. 
     * Variables du référentiel (non paginé)
     */
    async getVariables(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VariableDto>> {
        const response = await this.getVariablesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Variables rattachées à un contexte (tunnel)
     */
    async getVariablesByContextRaw(requestParameters: GetVariablesByContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FunnelVariableDto>>> {
        if (requestParameters['contextObjectId'] == null) {
            throw new runtime.RequiredError(
                'contextObjectId',
                'Required parameter "contextObjectId" was null or undefined when calling getVariablesByContext().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contextObjectId'] != null) {
            queryParameters['contextObjectId'] = requestParameters['contextObjectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/expressions/variablesValuesByContextNoPagedResult`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FunnelVariableDtoFromJSON));
    }

    /**
     * Variables rattachées à un contexte (tunnel)
     */
    async getVariablesByContext(requestParameters: GetVariablesByContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FunnelVariableDto>> {
        const response = await this.getVariablesByContextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Vérifie la formule (syntaxe NCalc, variables connues du référentiel) et la calcule avec les valeurs d\'essai fournies. Une formule fautive renvoie 200 avec `isSuccess=false` et `errorMessage`. Rien n\'est enregistré. 
     * Tester une formule de tarification à blanc
     */
    async testExpressionRaw(requestParameters: TestExpressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestExpressionResponse>> {
        if (requestParameters['testExpressionCommand'] == null) {
            throw new runtime.RequiredError(
                'testExpressionCommand',
                'Required parameter "testExpressionCommand" was null or undefined when calling testExpression().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/expressions/test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TestExpressionCommandToJSON(requestParameters['testExpressionCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestExpressionResponseFromJSON(jsonValue));
    }

    /**
     * Vérifie la formule (syntaxe NCalc, variables connues du référentiel) et la calcule avec les valeurs d\'essai fournies. Une formule fautive renvoie 200 avec `isSuccess=false` et `errorMessage`. Rien n\'est enregistré. 
     * Tester une formule de tarification à blanc
     */
    async testExpression(requestParameters: TestExpressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestExpressionResponse> {
        const response = await this.testExpressionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Modifier la valeur d\'une variable
     */
    async updateVariableValueRaw(requestParameters: UpdateVariableValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunnelVariableDto>> {
        if (requestParameters['updateVariableValueCommand'] == null) {
            throw new runtime.RequiredError(
                'updateVariableValueCommand',
                'Required parameter "updateVariableValueCommand" was null or undefined when calling updateVariableValue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/expressions/variableValue`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateVariableValueCommandToJSON(requestParameters['updateVariableValueCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunnelVariableDtoFromJSON(jsonValue));
    }

    /**
     * Modifier la valeur d\'une variable
     */
    async updateVariableValue(requestParameters: UpdateVariableValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunnelVariableDto> {
        const response = await this.updateVariableValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
